import component from './announcements.component';
import modal from './modal/modal.controller';
import service from './announcements.service';

export default angular.module('mpdx.common.announcements', [component, service, modal]).name;
